import React, { useState } from 'react';
import './../../styles/default/preguntas.css';

const Preguntas = () => {
    const [openIndex, setOpenIndex] = useState(-1);

    const toggle = (idx) => {
        setOpenIndex(openIndex === idx ? null : idx);
    };

    const queries = [
        {
            title: '¿Qué tipo de servicios ofrece Don Honesto? ',
            content: `Nos especializamos en servicios para el hogar y negocios como pintura, fontanería, electricidad y más. Solo trabajamos con profesionales verificados y comprometidos con la calidad. `
        },
        {
            title: '¿Cómo solicito un servicio?',
            content: `Solo selecciona el servicio que necesitas en nuestra página, llena el formulario, recibe una cotización preliminar y nosotros nos encargamos del resto. Fácil, rápido y confiable.`
        },
        {
            title: '¿Es seguro contratar por Don Honesto?',
            content: `Sí. Verificamos personalmente a cada profesional, y damos seguimiento durante todo el proceso. También puedes contactarnos en cualquier momento si tienes dudas o necesitas apoyo. `
        },
        {
            title: '¿Cuánto cuesta el servicio?',
            content: `Los precios dependen del tipo de trabajo. Algunos servicios ofrecen una pre-cotización automática, y en otros casos programamos una visita de diagnóstico sin compromiso.`
        },
        {
            title: '¿Qué pasa si el trabajo no queda bien?',
            content: `Estamos para ayudarte. Si hay cualquier inconveniente, nosotros intervenimos y damos seguimiento para que se resuelva de manera justa y rápida. Tu satisfacción es prioridad.`
        },
    ];

    return (
        <div id="preguntas" className='container-section section flex-row gap-40'>
            <div className="flex-column gap-20 full-width">
                <p className="title">Preguntas frecuentes</p>
                <h2>¿Tienes alguna duda?</h2>
                <h5>Resuelve tus dudas al instante</h5>
            </div>
            <div className="queries">
                {queries.map((q, idx) => (
                    <div key={idx} className={`query ${openIndex === idx ? 'open' : ''}`}>
                        <button className="query-header" onClick={() => toggle(idx)} aria-expanded={openIndex === idx}>
                            <span className="query-title">{q.title}</span>
                            <span className="query-icon">
                                <svg viewBox="0 0 16 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.430419 0.511935C0.494546 0.437112 0.572791 0.37566 0.660679 0.331092C0.748568 0.286523 0.844378 0.259711 0.942633 0.252188C1.04089 0.244666 1.13966 0.256581 1.23331 0.287251C1.32696 0.317921 1.41365 0.366746 1.48842 0.430935L8.00042 6.01193L14.5124 0.430935C14.6642 0.309064 14.8575 0.251007 15.0514 0.269038C15.2452 0.287069 15.4245 0.379774 15.5512 0.527556C15.6779 0.675338 15.7423 0.866615 15.7305 1.06095C15.7188 1.25529 15.632 1.43745 15.4884 1.56894L8.48842 7.56893C8.3525 7.6854 8.17941 7.74941 8.00042 7.74941C7.82143 7.74941 7.64834 7.6854 7.51242 7.56893L0.512419 1.56894C0.361604 1.43945 0.268359 1.25539 0.253171 1.0572C0.237983 0.859004 0.302094 0.662887 0.431419 0.511935" fill="black" />
                                </svg>
                            </span>
                        </button>

                        {openIndex === idx && (
                            <div className="query-content">
                                <p>{q.content}</p>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Preguntas;